// export const DARK_PURPLE = "#2_31b30";
// export const DARKER_PURPLE = "#1_10c1a";
// export const LIGHTER_PURPLE = "#3_0293b";

// export const BUTTON_COLOR = "#9_447ff";
// export const DARK_BUTTON_COLOR = "#2_92531";

// export const OUTLINED_INPUT_BACKGROUND = "#efeef1";


// export const BACKGROUND_WHITE = "#f7f7f8";
// export const SURFACE_WHITE = "#ffffff";
// export const SURFACE_WHITE_2 = "#edecef";
// export const TWICTH_PURPLE = "#5_f0098";

export const DARK_BLUE = "#1565C0";      // Blue[800]
export const DARKER_BLUE = "#0D47A1";    // Blue[900]
export const LIGHTER_BLUE = "#42A5F5";   // Blue[400]

export const BUTTON_COLOR = "#2196F3";     // Blue[500]
export const DARK_BUTTON_COLOR = "#1976D2"; // Blue[700]

export const OUTLINED_INPUT_BACKGROUND = "#f1f1f1ff"; // LightBlue[100]

export const BACKGROUND_WHITE = "#f7f7f8";  // keep grey-ish
export const SURFACE_WHITE = "#ffffff";     // keep white
export const SURFACE_WHITE_2 = "#edecef";   // keep grey-ish
export const TWICTH_PURPLE = BUTTON_COLOR;     // LightBlue[300]
